import { useNavigate } from "react-router-dom";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../app/redux/hooks";
import { paymentCheckoutAsync } from "../../../../../../app/slices/checkoutSlice/CheckoutSlice";
import { showSnackbar } from "../../../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import { useState } from "react";
import RenderRazorpay from "./RazorPay";
import axios from "../../../../../../axios";
import { useEffect } from "react";

export const PaymentPage = () => {
  const [displayRazorpay, setDisplayRazorpay] = useState(false);
  const [orderDetails, setOrderDetails] = useState({
    razorpayorderId: null,
    orderId: null,
    currency: "",
    amount: null,
  });

  const selectedAddressId = useAppSelector(
    (state) => state.CheckoutState.selectedAddressId
  );
  const selectedDeliverySlot = useAppSelector(
    (state) => state.CheckoutState.selectedDeliverySlot
  );
  const selectedDeliveryType = useAppSelector(
    (state) => state.CheckoutState.selectedDeliveryType
  );
  const selectedDeliveryDate = useAppSelector(
    (state) => state.CheckoutState.selectedDeliveryDate
  );
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const startDateString = selectedDeliveryDate
    .toString()
    .split(" to ")[0]
    .trim();
  const startDate = new Date(startDateString);
  const formattedSelectedDate = startDate.toISOString().split("T")[0];

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const appUrl: string | undefined = process.env.REACT_APP_API_URL;

  const handleCreateOrder = async () => {
    handlePaymentClick();
  };

  const handlePaymentClick = () => {
    let isPickup;
    if (selectedDeliveryType === "pickup") {
      isPickup = true;
    } else {
      isPickup = false;
    }
    const payload: any = {
      address_id: Number(selectedAddressId),
      // delivery_slot: Number(selectedDeliverySlot),
      pickup: isPickup,
      deliver_date: formattedSelectedDate,
    };
    if (!isPickup) {
      payload.delivery_slot = Number(selectedDeliverySlot);
    }
    dispatch(paymentCheckoutAsync(payload)).then((response: any) => {
      if (response?.payload?.status === 201) {
        if (response?.payload?.data?.data?.razorpay_order_id) {
          setOrderDetails({
            orderId: response?.payload?.data?.data?.order_id,
            razorpayorderId: response?.payload?.data?.data?.razorpay_order_id,
            currency: "INR",
            amount: response?.payload?.data?.data?.amount,
          });
          setDisplayRazorpay(true);
        }
      } else {
        dispatch(
          showSnackbar({
            message: "Please try again later.",
            severity: "error",
            autoHide: 3000,
          })
        );
      }
    });
  };

  return (
    <div>
      <h2>Choose Payment Method</h2>
      {/* {!displayRazorpay && ( */}
      <button
        className="tf-btn btn-fill animate-hover-btn radius-3 w-75 justify-content-center orange-b"
        onClick={() => handleCreateOrder()}
        // onClick={handlePaymentClick}
      >
        Proceed to pay
      </button>
      {/* // )} */}
      {displayRazorpay && orderDetails.razorpayorderId && (
        <RenderRazorpay
          amount={orderDetails.amount}
          currency={orderDetails.currency || "INR"}
          orderId={orderDetails.orderId}
          razorpayorderId={orderDetails.razorpayorderId}
          keyId={process.env.REACT_APP_RAZORPAY_KEY_ID}
          keySecret={process.env.REACT_APP_RAZORPAY_KEY_SECRET}
        />
      )}
    </div>
  );
};
